import { CSSProperties } from "react";

export type GenericComponentProps = Partial<{
  marginTop: string | number;
  marginBottom: string | number;
  marginLeft: string | number;
  marginRight: string | number;

  padding: string | undefined;
  paddingTop: string | undefined;
  paddingBottom: string | undefined;
  paddingLeft: string | undefined;
  paddingRight: string | undefined;

  width: string | number;
  minWidth: string | number;
  maxWidth: string | number;
  height: string | number;

  style: CSSProperties;
  className: string;
}>;

export const makeStyles = (props: GenericComponentProps, defaultProps?: GenericComponentProps): CSSProperties => {
  return {
    marginBottom: props.marginBottom ?? defaultProps?.marginBottom,
    marginLeft: props.marginLeft ?? defaultProps?.marginLeft,
    marginRight: props.marginRight ?? defaultProps?.marginRight,
    marginTop: props.marginTop ?? defaultProps?.marginTop,

    paddingTop: props.paddingTop ?? defaultProps?.paddingTop,
    paddingBottom: props.paddingBottom ?? defaultProps?.paddingBottom,
    paddingRight: props.paddingRight ?? defaultProps?.paddingRight,
    paddingLeft: props.paddingLeft ?? defaultProps?.paddingLeft,
    padding: props.padding ?? defaultProps?.padding,

    width: props.width ?? defaultProps?.width,
    minWidth: props.minWidth ?? defaultProps?.minWidth,
    maxWidth: props.maxWidth ?? defaultProps?.maxWidth,
    height: props.height ?? defaultProps?.height,

    ...(props.style ?? defaultProps?.style),
  };
};

